import { toggleFormHelp } from 'actions/ui';
import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch } from 'react-redux';

export const Edit = ({ show, onClose, onSave, selected, assignments }) => {
    const dispatch = useDispatch();
    const [due, setDue] = React.useState(null);
    const [userNames, setUserNames] = React.useState('');
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        setDue(null);
        setError(false);
        setSaving(false);
    }, [show]);

    React.useEffect(() => {
        const temp = assignments
            .filter(u => selected.some(s => s === u.id))
            .map(u => u.full_Name)
            .sort((a, b) => (a > b ? 1 : -1));
        setUserNames(temp.join(', '));
    }, [selected, assignments]);

    const validate = () => {
        if (!due) {
            setError(SystemText('PathwayTracker/Tabs/Enrolments/Edit/Fields/Due/Error'));
            setSaving(false);
            return false;
        }

        return true;
    };

    const footer = (
        <div>
            <SaveButton
                data-testid="edit-save"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={() => validate() && onSave(due)}
            >
                {SystemText('Admin/General/Modal/Buttons/Update')}
            </SaveButton>
            <button className="btn" onClick={() => onClose()} data-testid="edit-cancel">
                {SystemText('Admin/General/Modal/Buttons/Cancel')}
            </button>
        </div>
    );

    return (
        <Modal
            show={show}
            close={onClose}
            title={SystemText('PathwayTracker/Tabs/Enrolments/Edit/Title')}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <div className="form-group">
                <Forms.Label
                    label={SystemText('PathwayTracker/Tabs/Enrolments/Edit/Fields/Users/Title')}
                    help={SystemText('PathwayTracker/Tabs/Enrolments/Edit/Fields/Users/Help')}
                    value={userNames}
                />
                <Forms.Date
                    label={SystemText('PathwayTracker/Tabs/Enrolments/Edit/Fields/Due/Title')}
                    help={SystemText('PathwayTracker/Tabs/Enrolments/Edit/Fields/Due/Help')}
                    mandatory
                    error={error}
                    value={due}
                    onChange={setDue}
                />
            </div>
        </Modal>
    );
};

export default Edit;
